import { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { User } from '../../components/Tables';
import { authService } from '../../services';
import { transformAdminToUser } from './Admins.utils';

export const useAdmins = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchAdmins = useCallback(async () => {
    try {
      setLoading(true);
      const response = await authService.getAllAdmins();
      
      // Get current user email from localStorage
      const storedEmail = localStorage.getItem('userEmail');
      
      // Transform API data to User format
      const transformedUsers = response.data.admins.map(admin => 
        transformAdminToUser(admin, storedEmail || undefined)
      );
      
      setUsers(transformedUsers);
    } catch (error: any) {
      console.error('Failed to fetch admins:', error);
      toast.error(error?.response?.data?.message || 'Failed to load users');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAdmins();
  }, [fetchAdmins]);

  return { users, loading, refetch: fetchAdmins };
};

